import React from 'react';

function PaymentTypeLabelCase(productType) {
	switch(productType) {
		case "momo_transfer": {
			return "Ví Momo"
		}
		case "vnpay" : {
			return "Cổng Thanh Toán VNPAY"
		}
		case "paypal" : {
			return "Paypal"
		}
		case "bank_transfer" : {
			return "Chuyển Khoản Ngân Hàng"
		}
		case "tadu_account" : {
			return "Tài Khoản Chính Tadu"
		}
		case "reward_account" : {
			return "Tài Khoản Khuyến Mãi Tadu"
		}
		default: {
			return "Tất cả phương thức"
		}
	}
}

class PaymentTypeSelect extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const {payment_type_selected, onPaymentTypeSelect, is_product_config} = this.props;
        return(
            <React.Fragment>
                <div style={{float: 'right'}} className="btn-group">
                    <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                        {PaymentTypeLabelCase(payment_type_selected)}
                    </button>
                    <div className="dropdown-menu" x-placement="bottom-start">
                        <a onClick={() => onPaymentTypeSelect("all")} className="dropdown-item">Tất cả dịch vụ</a>
                        <a onClick={() => onPaymentTypeSelect("momo_transfer")} className="dropdown-item">Ví Momo</a>
                        <a onClick={() => onPaymentTypeSelect("vnpay")} className="dropdown-item">Cổng Thanh Toán VNPAY</a>
                        <a onClick={() => onPaymentTypeSelect("paypal")} className="dropdown-item">Paypal</a>
                        <a onClick={() => onPaymentTypeSelect("bank_transfer")} className="dropdown-item">Chuyển Khoản Ngân Hàng</a>
                        <a onClick={() => onPaymentTypeSelect("tadu_account")} className="dropdown-item">Tài Khoản Chính Tadu</a>
                        <a onClick={() => onPaymentTypeSelect("reward_account")} className="dropdown-item">Tài Khoản Khuyến Mãi</a>
                    </div>
                </div>
            </React.Fragment>
        )
    }

}


export default PaymentTypeSelect;